import React from "react";

export default function Upload({ userData }) {
  const openFile = e => {
    console.log("open sesame");
    let status = [];
    const fileObj = e.target.files[0];
    const reader = new FileReader();
    let fileLoaded = e => {
      const fileContents = e.target.result;
      status.push(
        `File name: ${fileObj.name} \n Length: ${fileContents.length} bytes`
      );
      const first80char = fileContents.substring(0, 80);
      status.push(`First 80 chars: \n${first80char}`);
    };
    reader.onload = function(fileLoaded) {
      const data = fileLoaded.target.result;
      userData(data);
    };
    reader.readAsText(fileObj);
  };

  return (
    <label className="ui left floated button" htmlFor="upload-btn">
      <i className="upload icon" />Upload Data
      <input
        className="hidden"
        id="upload-btn"
        type="file"
        multiple={false}
        accept=".json"
        onChange={e => openFile(e)}
      />
    </label>
  );
}
